import { displayFilters } from '../../../resources/filters/actions';
import { useAppDispatch } from '../../../shared/redux';

import s from './MobileFiltersButton.css';

export const FiltersButton = (): JSX.Element => {
    const dispatch = useAppDispatch();
    return (
        <button type="button" onClick={() => dispatch(displayFilters())} className={s.button}>
            <div />
            <div />
            <div />
        </button>
    );
};
